import React, { useEffect, useState } from "react";
import WebIcon from "@mui/icons-material/Web";
import { Box, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import { Header } from "./components/Header";
import NavItem from "./MenuItem/NavItem";
import { ReactComponent as GridsOutlinedIcon } from "../../assets/icons/grids-outlined.svg";
import { ReactComponent as InsightsTimelineIcon } from "../../assets/icons/insights-timeline.svg";
import { ReactComponent as Sortimento } from "../../assets/icons/sortimento.svg";
import FormulaLogoFooter from "../../assets/img/logo-footer-execellence.png";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 15));
    });
  }

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();

  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="containerLeftSideMenu">
        <Header leftBarOpened={leftBarOpened} />

        <div className="leftSideClientContainer">
          {leftBarOpened && (
            <h2 className="titleSideCLient">CAMPANHA DE INCENTIVO</h2>
          )}
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent"
              : "leftSideContent leftSideContent-open"
          }
        >
          <ul>
            <NavItem
              muiIcon={<WebIcon />}
              name="Visão Geral"
              path="/overview"
            />
            <ul>
              <NavItem
                muiIcon={<GridsOutlinedIcon />}
                name="Detalhamento"
                path="/details"
              />
            </ul>

            <NavItem muiIcon={<Sortimento />} name="Pilares" path="/pilares" />

            <NavItem
              muiIcon={<InsightsTimelineIcon />}
              name="MSL"
              path="/msl"
            />
          </ul>

          {/* <NavItem
            muiIcon={<ArrowCircleUpIcon />}
            name="Gestão de Dados"
            path="/ims"
          />

          <NavItem
            muiIcon={<HourglassBottomIcon />}
            name="Ações Pendentes"
            path="/pending-actions"
          /> */}
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent leftSideContent-second"
              : "leftSideContent leftSideContent-second leftSideContent-open"
          }
        ></div>

        {leftBarOpened && (
          <Grid
            flexDirection={"column"}
            alignItems={"flex-start"}
            columnGap={1}
            className="leftSideFooter"
          >
            <Grid item>
              <Box
                component={"img"}
                src={FormulaLogoFooter}
                className="container-img-leftSide"
              />
            </Grid>
            <Grid item>
              <span>Atualizado em: {dataAtualizacao} </span>
            </Grid>
          </Grid>
        )}
      </div>

      <div className="containerCloseSideMenu">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          {leftBarOpened ? (
            <ArrowBackIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#FE576D" }}
            />
          ) : (
            <ArrowForwardIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#FE576D" }}
            />
          )}
        </button>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
